import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Svg from 'svg-inline-react';
import { useHistory } from 'react-router-dom';
import { setErrorFlashMessage, setSuccessFlashMessage } from '@src/redux/actions/flashMessages';
import ChevronRightSvg from '@src/svgs/fr-chevron-right.svg';
import { InfoNotice } from '@src/components/InfoNotice';
import { FUNNEL_EDIT_ROUTE } from '@src/Routes/links';
import { createLink } from '@src/util/createLink';
import { MetricContext, MetricEventSource, MetricAction } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import { useDuplicateOpeningMutation } from '@src/graphql/generated';
import './styles.scss';

export const _ScrapedOpeningInfoNotice = ({ openingId, setErrorFlashMessage, setSuccessFlashMessage }) => {
  const history = useHistory();

  const [duplicateOpening] = useDuplicateOpeningMutation({
    onCompleted: ({ duplicateOpening: opening }) => {
      history.push(createLink({ link: FUNNEL_EDIT_ROUTE, params: { openingId: opening.id } }));

      setSuccessFlashMessage(`The opening ${opening.title} is successfully duplicated.`);

      trackEvent({
        context: MetricContext.OPENING_VIEW,
        interaction: MetricAction.CLICK_ADD_TARGETING_BUTTON,
        payload: {
          'Event Source': MetricEventSource.CLICK_ADD_TARGETING_BUTTON,
          'Previous Context': MetricContext.OPENING_VIEW,
        },
      });
    },
    onError: () => {
      setErrorFlashMessage();
    },
  });

  return (
    <InfoNotice>
      <div className="scraped-opening-info-notice__text">
        You can reach people more accurately and have your offer pushed to the best matching talent.
      </div>

      <div className="scraped-opening-info-notice__link" onClick={() => duplicateOpening({ variables: { openingId } })}>
        <span className="scraped-opening-info-notice__link-text">Add targeting</span>

        <Svg className="scraped-opening-info-notice__link-icon" src={ChevronRightSvg} />
      </div>
    </InfoNotice>
  );
};

_ScrapedOpeningInfoNotice.propTypes = {
  openingId: PropTypes.string.isRequired,
  setErrorFlashMessage: PropTypes.func.isRequired,
  setSuccessFlashMessage: PropTypes.func.isRequired,
};

export const ScrapedOpeningInfoNotice = connect(null, {
  setErrorFlashMessage: setErrorFlashMessage,
  setSuccessFlashMessage: setSuccessFlashMessage,
})(_ScrapedOpeningInfoNotice);
